module.exports = __webpack_public_path__ + "static/media/messages.98eab5ee.svg";